<template>
  <b-row v-if="!loading">
    <ProfilePicture :userId="userId" />
    <ProfileDetails :userData="data.generalInfo" :userId="userId" />
    <ProfileLocations :locationData="data.Locations" :userId="userId" />
  </b-row>
</template>

<script>
import ProfilePicture from "../../components/ProfilePicture";
import ProfileDetails from "../../components/ProfileDetails";
import ProfileLocations from "../../components/ProfileLocations";

export default {
  name: "dashboard",
  components: {
    ProfilePicture,
    ProfileDetails,
    ProfileLocations
  },
  data() {
    return {
      userId: null,
      data: [],
      loading: true
    };
  },
  methods: {
    getInfo() {
      let params = {
        userId: this.userId
      };
      this.$http.get("api/atx/profile/userInfo.php", { params }).then(
        res => {
          this.data = res.data;
          this.loading = false;
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  mounted() {
    this.userId = localStorage.getItem("atx_user");
    this.getInfo();
  }
};
</script>

<style scoped></style>
